export default {"src":"/_next/static/media/help-icon.b9ed52f0.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};